import type { HomeInstitutionEventDto } from '@generated/unauth';

import { DONATION_ROUTES, ROUTES, WEBVIEW_TYPE_ENTRY } from '@/constants';
import { getStaticCdnUrl } from '@/utils';
import { checkTodayInRange } from '@/utils/checkTodayInRange';

import { CARD_PROMOTIONS } from '../../_constants/cardEventBanners';

type MainBannerItem = {
  title: string;
  imageUrl: string;
  href: string;
  target?: string;
  eventId?: HomeInstitutionEventDto['eventId'];
};

export const filterMainBannerItems = (
  data: HomeInstitutionEventDto[],
  entry: string,
) => {
  const mainBannerItems: MainBannerItem[] =
    data
      ?.filter((item) => item && item.title)
      .map((item) => ({
        title: item.title,
        imageUrl: item.thumbnailUrl,
        href: DONATION_ROUTES.MY_ETC_EVENT_DETAIL.pathname({
          eventId: item.eventId,
        }),
        eventId: item.eventId,
      })) ?? [];

  const cardPromotions: MainBannerItem[] =
    entry === 'WELLO' ? [...CARD_PROMOTIONS.main] : [];

  const localMarketItem: MainBannerItem | null =
    entry === WEBVIEW_TYPE_ENTRY.WELLO
      ? {
          href: '/welmarket',
          title: '웰마켙 오픈',
          imageUrl:
            'https://cdn.welfarehello.com/static/local-market/home/hero-banner-pc-bg-1.png',
        }
      : null;

  const upgradeItem: MainBannerItem | null =
    entry !== WEBVIEW_TYPE_ENTRY.TOSS
      ? {
          href: '/community/policyInfo/1ea2bcd4-0705-4f32-a403-37fb3cae8910',
          title: '2026년 고향사랑기부제 공제율 최대 44% 확대',
          imageUrl:
            'https://cdn.welfarehello.com/static/banner/donation-upgrade.png',
        }
      : null;

  const tongyeongFloodItem: MainBannerItem | null =
    entry !== WEBVIEW_TYPE_ENTRY.TOSS &&
    checkTodayInRange('2026-08-18T00:00:00+09:00', '2026-09-30T23:59:59+09:00')
      ? {
          href: ROUTES.POLICY_INFO_DETAIL.pathname({
            idIdx:
              '6719-%EA%B7%B9%ED%95%9C%ED%98%B8%EC%9A%B0-%EB%8D%AE%EC%B9%9C-%ED%86%B5%EC%98%81-%EB%8B%A4%EC%8B%9C-%ED%91%B8%EB%A5%B8-%ED%86%B5%EC%98%81%EC%9D%84-%ED%95%A8%EA%BB%98-%EB%A7%8C%EB%93%A4%EC%96%B4-%EC%A3%BC%EC%84%B8%EC%9A%94--3b1cd13f-d95f-4eff-8e0a-5d005022a158',
          }),
          title: '통영 집중호우 피해 복구 지정기부',
          imageUrl: getStaticCdnUrl('banner/donation-tongyeong-flood-2608.png'),
        }
      : null;

  const sortedMainBannerItems: MainBannerItem[] = [
    tongyeongFloodItem,
    localMarketItem,
    ...cardPromotions,
    upgradeItem,
    ...mainBannerItems,
    {
      href: 'https://blink.do/Wello',
      title: '연말정산 보험 환급액 확인하기',
      imageUrl: 'https://cdn.welfarehello.com/static/banner/signal.png',
    },
  ].filter(
    (item): item is NonNullable<typeof item> =>
      item !== null && item !== undefined,
  );

  return sortedMainBannerItems;
};
